import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";
import { Workbook } from "../interface";

async function getWorkbooks(secondary = false): Promise<void> {
    if (api.clientApi) {
        const list = await api.clientApi.clientWorkbookList(store.db ? store.db : "", !secondary, undefined).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
            return response as unknown as Workbook[];
        });

        if (!secondary) {
            store.setWorkbookCount(list.length || 0);
            store.setWorkbooks(list || []);
        } else {
            store.setSecondaryWorkbookCount(list.length || 0);
            store.setSecondaryWorkbooks(list || []);
        }
    }
}

export { getWorkbooks };
